import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";

import { withStyles } from "@material-ui/core/styles";

import cong1 from "../images/mds/month-1.png";
import cong2 from "../images/mds/month-2.png";
import cong3 from "../images/mds/month-3.png";
import cong4 from "../images/mds/month-4.png";
import cong5 from "../images/mds/month-5.png";
import cong6 from "../images/mds/month-6.png";
import cong7 from "../images/mds/month-7.png";
import cong8 from "../images/mds/month-8.png";
import cong9 from "../images/mds/month-9.png";
import cong10 from "../images/mds/month-10.png";
import cong11 from "../images/mds/month-11.png";
import cong12 from "../images/mds/month-12.png";

const styles = theme => ({
  img: {
    width: "100%",
    height: "100%"
  },
  none: {
    display: "none"
  }
});

@observer
class CodeMapCongImgSet extends Component {
  //===========================================================================
  @observable cong = cong1;
  //===========================================================================

  render() {
    const { classes, step, closeCong, imgset } = this.props;
    const { img, none } = classes;
    this.changeCong();
    return (
      <img
        src={this.cong}
        alt={step + "단계 돌파 성공"}
        onClick={closeCong}
        className={imgset === "mro201906290109070001" ? img : none}
      />
    );
  }
  //===========================================================================

  @action
  changeCong = () => {
    const { step } = this.props;
    switch (step) {
      case 2:
        this.cong = cong1;
        break;
      case 4:
        this.cong = cong2;
        break;
      case 6:
        this.cong = cong3;
        break;
      case 8:
        this.cong = cong4;
        break;
      case 10:
        this.cong = cong5;
        break;
      case 12:
        this.cong = cong6;
        break;
      case 14:
        this.cong = cong7;
        break;
      case 16:
        this.cong = cong8;
        break;
      case 18:
        this.cong = cong9;
        break;
      case 20:
        this.cong = cong10;
        break;
      case 22:
        this.cong = cong11;
        break;
      case 24:
        this.cong = cong12;
        break;
      default:
    }
  };
  //===========================================================================
}

export default withStyles(styles)(CodeMapCongImgSet);
